import { Inject, Injectable } from '@angular/core';
import { IMutableContext, UnleashClient } from 'unleash-proxy-client';

import { UNLEASH_CONFIGURATION, UnleashConfiguration } from '../interface/feature-flags.interfaces';
import { DataAccessTogglesFacade } from '../states/toggles/data-access-toggles.facade';

@Injectable()
export class FeatureFlagsService {
  unleash: UnleashClient;

  constructor(@Inject(UNLEASH_CONFIGURATION) config: UnleashConfiguration, private facade: DataAccessTogglesFacade) {
    this.unleash = new UnleashClient({
      url: config.url,
      clientKey: config.clientKey,
      appName: config.appName,
      environment: config.environment,
    });

    const update = () => {
      let state = {};

      this.toggles().forEach(
        (toggle: {
          name: string;
          enabled: boolean;
          variant: {
            name: string;
            enabled: boolean;
            payload?: {
              type: string;
              value: string;
            };
          };
          impressionData: boolean;
        }) => {
          state = {
            ...state,
            [toggle.name]: toggle.enabled,
          };
        }
      );

      this.facade.update(state);
    };

    this.unleash.on('ready', update);
    this.unleash.on('update', update);
  }

  start(): void {
    this.unleash.start();
  }

  stop(): void {
    this.unleash.stop();
  }

  updateContext(contextObj: IMutableContext): void {
    this.unleash.updateContext(contextObj);
  }

  isEnabled(feature: string): boolean {
    return this.unleash.isEnabled(feature);
  }

  toggles() {
    return this.unleash.getAllToggles();
  }
}
